/**
 * Internal dependencies
 */
import { SET_NAVBAR_COLOR } from '../actionTypes';
import { createAction } from '../action-creators';
import { RootState } from '../types';

export const setNavBarColor =
	createAction<RootState['navBarColor']>(SET_NAVBAR_COLOR);
